module.exports = __webpack_public_path__ + "static/media/play-overlay.2c15f2c1.svg";